import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const MagazinePage = lazy(() => import('../pages/magazine/page'));
const AProposPage = lazy(() => import('../pages/a-propos/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ArticlePage = lazy(() => import('../pages/blog/article/page'));
const MentionsLegalesPage = lazy(() => import('../pages/mentions-legales/page'));
const ConfidentialitePage = lazy(() => import('../pages/confidentialite/page'));
const ConditionsPage = lazy(() => import('../pages/conditions/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/magazine',
    element: <MagazinePage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <ArticlePage />,
  },
  {
    path: '/a-propos',
    element: <AProposPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/mentions-legales',
    element: <MentionsLegalesPage />,
  },
  {
    path: '/confidentialite',
    element: <ConfidentialitePage />,
  },
  {
    path: '/conditions',
    element: <ConditionsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
